import {useLayoutEffect, useState} from "react"
import {useSelector} from "react-redux"

import {breakpoints} from "@next/themes"
import {useHasReachedFooter} from "./useHasReachedFooter"
import {selectIsFetchingNextPage} from "../../ducks/search"
import {MOBILE_VIEWPORT_SIZE} from "../../models/ViewportSize"
import breakpointToViewportSize from "../../utils/breakpointToViewportSize"
import useMediaQuery from "../useMediaQuery"

export function useHideFixedItems() {
    const [hideFixedItems, setHideFixedItems] = useState(false)
    const {hasReachedFooter, calculateHasReachedFooter} = useHasReachedFooter()
    const isFetchingNextPage = useSelector(selectIsFetchingNextPage)
    const isXs = useMediaQuery(`(min-width: ${breakpoints.values.xs}px)`)
    const isSm = useMediaQuery(`(min-width: ${breakpoints.values.sm}px)`)
    const isMd = useMediaQuery(`(min-width: ${breakpoints.values.md}px)`)
    const isLg = useMediaQuery(`(min-width: ${breakpoints.values.lg}px)`)
    const isXl = useMediaQuery(`(min-width: ${breakpoints.values.xl}px)`)
    const isXxl = useMediaQuery(`(min-width: ${breakpoints.values.xxl}px)`)

    // eslint-disable-next-line no-nested-ternary
    const currentBreakpoint = isXxl ? "xxl" : isXl ? "xl" : isLg ? "lg" : isMd ? "md" : isSm ? "sm" : isXs ? "xs" : "xs"
    const viewport: string = breakpointToViewportSize(currentBreakpoint)

    useLayoutEffect(() => {
        if (viewport === MOBILE_VIEWPORT_SIZE || isFetchingNextPage || !hasReachedFooter) {
            setHideFixedItems(false)
        } else if (!isFetchingNextPage && hasReachedFooter) {
            const isCloseToFooter = calculateHasReachedFooter(true)
            setHideFixedItems(!!isCloseToFooter && hasReachedFooter)
        }
    }, [viewport, isFetchingNextPage, hasReachedFooter, calculateHasReachedFooter])

    return {
        hideFixedItems,
    }
}
